import { Helmet } from 'react-helmet-async';

export const SEO = ({
  title = 'Asbestosurv | Professional Asbestos Surveys & Management',
  description = 'Professional asbestos surveys across the UK. Management & refurbishment surveys — quotes tailored to your property. BOHS P402 / RSPH Level 3 qualified surveyors, independent UKAS accredited lab. Reports in 24-48 hours. Call 07704 885084.',
  keywords = 'asbestos survey, asbestos management, CAR 2012, asbestos survey UK',
  canonical,
  structuredData,
  noindex = false
}) => {
  const siteUrl = 'https://asbestosurv.co.uk';
  const fullCanonical = canonical || (typeof window !== 'undefined' ? `${siteUrl}${window.location.pathname}` : siteUrl);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:site_name" content="Asbestosurv" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* AI Crawlability */}
      <meta name="ai-content-declaration" content="human-created" />

      {/* Geo Tags */}
      <meta name="geo.region" content="GB-ESS" />
      <meta name="geo.placename" content="Maldon, Essex" />
      <meta name="geo.position" content="51.7316;0.6770" />
      <meta name="ICBM" content="51.7316, 0.6770" />

      {/* JSON-LD Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};
